export default {
  getAddresses: state => state.items
}



// WEBPACK FOOTER //
// ./src/store/modules/addresses/getters.js